export default {"fontFamily":"'Titillium Web', 'Titillium', sans-serif"};